import React, { useState, useEffect } from "react";
import moment from "moment";
import { Helmet } from "react-helmet";
import DataParser from "../../../utlits/Dataparser";
import PhyicalYearService from "../../../Services/PhyicalYearService";
import { Link } from "react-router-dom";
import SocketService from "../../../Services/SocketService";
import { message } from "antd";
import TableSkeleton from "../../Reuseable/TableSkeleton";

message.config({ zIndex: 1000000001 });

const LeavePeriod = () => {
  const [isLoading, setIsLoading] = useState(false);
  const compid = DataParser.CompanyId();
  const [seasionsList, setSeasonList] = useState([]);
  const [userPermissions, setuserPermissions] = useState([]);

  useEffect(() => {
    getLeaveSession();
    const upermission = DataParser.CompanyUserPermissions();
    setuserPermissions(upermission);
  }, []);

  useEffect(() => {
    SocketService.connect();
    const companyId = DataParser.CompanyId();
    const handleSettingsUpdate = (data) => {
      if (Number(data.company_id) === Number(companyId)) {
        getLeaveSession();
      }
    };
    SocketService.on("leavesession_update", handleSettingsUpdate);
    return () => {
      SocketService.off("leavesession_update", handleSettingsUpdate);
    };
  }, []);

  const getLeaveSession = () => {
    setIsLoading(true);
    PhyicalYearService.getPhysicalYear(compid)
      .then((res) => {
        const data = res.data.Settings;
        setSeasonList(data);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const toggleStatus = (id, currentStatus) => {
    const newStatus = currentStatus === 1 ? 0 : 1;
    PhyicalYearService.updatePhysicalYear(id, newStatus, {})
      .then(() => {
        message.success("Status updated successfully!");
        getLeaveSession();
      })
      .catch((err) => {
        console.error("Error updating status:", err);
        message.error("Failed to update status. Please try again!");
      });
  };

  return (
    <>
      <Helmet>
        <title>Annual Leave Period - Planit</title>
      </Helmet>
      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 px-0">
                <div className="d-flex align-items-end justify-content-end" style={{ padding: "0 0 12px 0" }}>
                  <div className="d-flex flex-column align-items-end" style={{ gap: "6px" }}>
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}>Home</Link>
                      </li>
                      <li className="breadcrumb-item active">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/settings`}>Settings</Link>
                      </li>
                      <li className="breadcrumb-item active">Annual Leave Period</li>
                    </ol>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 px-0">
                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                  <div className="card-body p-0">
                    <div className="table-responsive listing-table-wrapper">
                      <table className="table mb-0 custom-table listing-table">
                        <thead>
                          <tr className="tableHeaderbg">
                            <th>Sr#</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading ? (
                            <TableSkeleton cols={4} rows={6} />
                          ) : seasionsList && seasionsList.length > 0 ? (
                            seasionsList.map((item, index) => (
                              <tr key={item.id}>
                                <td>{index + 1}</td>
                                <td>
                                  <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                                    <i className="uil uil-calendar-alt" style={{ color: "#0DDFAB", fontSize: "16px", flexShrink: 0 }} />
                                    {item.start_date ? moment(item.start_date).format("D, MMMM YYYY") : "—"}
                                  </span>
                                </td>
                                <td>
                                  <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                                    <i className="uil uil-calendar-alt" style={{ color: "#0DDFAB", fontSize: "16px", flexShrink: 0 }} />
                                    {item.end_date ? moment(item.end_date).format("D, MMMM YYYY") : "—"}
                                  </span>
                                </td>
                                <td>
                                  {userPermissions.indexOf("departments-delete") !== -1 ? (
                                    item.status === 1 ? (
                                      <button
                                        className="btn btn-success waves-effect waves-light btn-sm"
                                        onClick={() => toggleStatus(item.id, item.status)}
                                      >
                                        Active
                                      </button>
                                    ) : (
                                      <button
                                        className="btn btn-danger waves-effect waves-light btn-sm"
                                        onClick={() => toggleStatus(item.id, item.status)}
                                      >
                                        Deactive
                                      </button>
                                    )
                                  ) : (
                                    item.status === 1 ? (
                                      <button
                                        type="button"
                                        className="btn btn-success waves-effect waves-light btn-sm"
                                        disabled
                                        style={{ opacity: 0.6, cursor: "not-allowed" }}
                                      >
                                        Active
                                      </button>
                                    ) : (
                                      <button
                                        type="button"
                                        className="btn btn-danger waves-effect waves-light btn-sm"
                                        disabled
                                        style={{ opacity: 0.6, cursor: "not-allowed" }}
                                      >
                                        Deactive
                                      </button>
                                    )
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No leave period records found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeavePeriod;
